import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <div className='footer-div'>
      <p>&copy; Copyright {new Date().getFullYear()}. All rights Reserved. Developed by Mann Kawatkar.</p>
    </div>
  )
}

export default Footer
